import React from 'react';
import CrudPage from '../../components/CrudPage';
import { blogCategoryApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'categoryId' },
  { header: 'Category Name', field: 'categoryName' },
  { header: 'Description', field: 'description' },
];

const BlogCategoryPage = () => (
  <CrudPage
    title="Blog Categories"
    subtitle="View blog categories (read-only)"
    api={blogCategoryApi}
    columns={columns}
    formFields={[]}
    idField="categoryId"
    searchField="categoryName"
    disableCreate={true}
    disableEdit={true}
    disableDelete={true}
  />
);

export default BlogCategoryPage;
